import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store.js'

// Authenticate ==========================================
import AuthIndex from './views/auth/Index.vue'
import AuthRegsiter from './views/auth/Register.vue'
import AuthLogin from './views/auth/Login.vue'
import AuthLoginVerify from './views/auth/LoginVerify.vue'
// import AuthForget from './views/auth/Forget.vue'
// import AuthForgetVerify from './views/auth/ForgetVerify.vue'
// Account Page ==========================================
import AccountIndex from './views/account/Index.vue'
import AccountUpgrade from './views/account/Upgrade.vue'
import AccountDataDiri from './views/account/DataDiri.vue'
import AccountDataOutlet from './views/account/DataOutlet.vue'
import AccountDeveloper from './views/account/Developer.vue'
import AccountEmail from './views/account/Email.vue'
import AccountPin from './views/account/Pin.vue'
import AccountPertanyaan from './views/account/Pertanyaan.vue'
// Info Page =============================================
import InfoIndex from './views/info/Index.vue'
// Referral Page =============================================
import ReferralIndex from './views/referral/Index.vue'
import ReferralDownline from './views/referral/Downline.vue'
import ReferralKomisi from './views/referral/Komisi.vue'
// History Transaction =============================================
import TransactionIndex from './views/transaction/Index.vue'
import TransactionPrabayarShow from './views/transaction/prabayar/Show.vue'
import TransactionPascabayarShow from './views/transaction/pascabayar/Show.vue'
import TransactionDepositShow from './views/transaction/deposit/Show.vue'
// Page =============================================
import PageAbout from './views/page/About.vue'
import PageTOS from './views/page/TOS.vue'
import PageFAQ from './views/page/FAQ.vue'
import PagePrivacy from './views/page/Privacy.vue'
import PageOther from './views/page/Other.vue'
// Other Page =============================================
import Beranda from './views/Beranda.vue'
import Other from './views/Other.vue'
import Deposit from './views/Deposit.vue'
import Transfer from './views/Transfer.vue'
import Withdrawal from './views/Withdrawal.vue'
import ProductPrabayar from './views/ProductPrabayar.vue'
import OrderPrabayar from './views/OrderPrabayar.vue'
import Prabayar from './views/Prabayar.vue'

import ProductPrabayarPrefix from './views/ProductPrabayarPrefix.vue'


import Pascabayar from './views/Pascabayar.vue'
import Mutasi from './views/Mutasi.vue'
// Error Page =============================================
import NotFound from './views/404.vue'
import AccessDenied from './views/403.vue'

import CareCenter from './views/CareCenter.vue'

import Kemitraan from './views/Kemitraan.vue'

import Forward from './views/page/Forward.vue'

Vue.use(VueRouter)

const routes = [
    // Authenticate ==========================================
    {path: '/auth',component: AuthIndex,children:[
        {path:'register', name:'auth.register', component:AuthRegsiter},
        {path:'login', name:'auth.login', component:AuthLogin},
        {path:'login/verify', name:'auth.login.verify', component:AuthLoginVerify},
        // {path:'forget', name:'auth.forget', component:AuthForget},
        // {path:'forget/verify', name:'auth.forget.verify', component:AuthForgetVerify},
    ]},
    // Account Page ==========================================
    {path:'/account', name:'account', component:AccountIndex, meta: { requiresAuth: true }},
    {path:'/account/upgrade', name:'account.upgrade', component:AccountUpgrade, meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
        if(store.state.customer.role == 'Member') next()
        else next({ name: 'account' })
    }},
    {path:'/account/data-diri', name:'account.data-diri', component:AccountDataDiri, meta: { requiresAuth: true }},
    {path:'/account/data-outlet', name:'account.data-outlet', component:AccountDataOutlet, meta: { requiresAuth: true }},
    {path:'/account/developer', name:'account.developer', component:AccountDeveloper, meta: { requiresAuth: true }},
    {path:'/account/email', name:'account.email', component:AccountEmail, meta: { requiresAuth: true }},
    {path:'/account/pin', name:'account.pin', component:AccountPin, meta: { requiresAuth: true }},
    {path:'/account/question', name:'account.question', component:AccountPertanyaan, meta: { requiresAuth: true }},
    // Info Page =============================================
    {path:'/info', name:'info.index', component:InfoIndex, meta: { requiresAuth: true }, props: true},
    // Referral Page =============================================
    {path:'/referral', name:'referral.index', component:ReferralIndex, meta: { requiresAuth: true }},
    {path:'/referral/downline', name:'referral.downline', component:ReferralDownline, meta: { requiresAuth: true }},
    {path:'/referral/komisi', name:'referral.komisi', component:ReferralKomisi, meta: { requiresAuth: true }},
    // History Transaction =============================================
    {path:'/transaction', name:'transaction.index', component:TransactionIndex, meta: { requiresAuth: true }},
    {path:'/transaction/prabayar/:id', name:'transaction.prabayar.show', component:TransactionPrabayarShow, meta: { requiresAuth: true }},
    {path:'/transaction/pascabayar/:id', name:'transaction.pascabayar.show', component:TransactionPascabayarShow, meta: { requiresAuth: true }},
    {path:'/transaction/deposit/:id', name:'transaction.deposit.show', component:TransactionDepositShow, meta: { requiresAuth: true }},
    // Page =============================================
    {path: '/about',name: 'about',component: PageAbout,meta: { requiresAuth: true }},
    {path: '/tos',name: 'tos',component: PageTOS},
    {path: '/faq',name: 'faq',component: PageFAQ,meta: { requiresAuth: true }},
    {path: '/privacy',name: 'privacy',component: PagePrivacy},
    {path: '/page/:slug',name: 'page.other',component: PageOther,meta: { requiresAuth: true }, props: true},
    // Other Page =============================================
    {path: '/',name: 'home',component: Beranda,meta: { requiresAuth: true }},
    {path: '/other',name: 'other',component: Other,meta: { requiresAuth: true }},
    {path: '/product-prabayar/:id',name: 'product-prabayar',component: ProductPrabayar,meta: { requiresAuth: true }, props: true},
    {path: '/order-prabayar/:id',name: 'order-prabayar',component: OrderPrabayar,meta: { requiresAuth: true }, props: true},

    {path: '/product-prabayar-prefix/:id',name: 'product-prabayar-prefix',component: ProductPrabayarPrefix,meta: { requiresAuth: true }, props: true},

    {path: '/prabayar/:id',name: 'prabayar',component: Prabayar,meta: { requiresAuth: true }, props: true},
    {path: '/pascabayar/:id',name: 'pascabayar',component: Pascabayar,meta: { requiresAuth: true }, props: true},
    {path: '/deposit',name: 'deposit',component: Deposit},
    {path: '/transfer',name: 'transfer',component: Transfer},
    {path: '/withdrawal',name: 'withdrawal',component: Withdrawal},
    {path: '/mutasi',name: 'mutasi',component: Mutasi},

    {path:'/kemitraan', name:'kemitraan', component:Kemitraan, meta: { requiresAuth: true }},
    
    // Error Page =============================================
    {path: '/care-center', name:'care-center', component: CareCenter},
    {path: '/404', name:'404', component: NotFound},
    {path: '/403', name:'403', component: AccessDenied, props: true},
    {path: '/forward', name:'forward', component: Forward, props: true},
    {path: '*', redirect: '/404'}, 
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 };
    },
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        let auth = store.getters.isAuth
        if (!auth) next({ name: 'auth.login' })
        else next()
    } else {
        next()
    }
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAPK)){
        const userAgent = navigator.userAgent
        if(userAgent.substring(userAgent.length - 17, userAgent.length - 1) == store.state.VUE_ENV.VUE_APP_PACKAGENAME_APK){
            next()
        } else {
            store.commit('SET_TOAST', {show:true,message:'Halaman ini tidak dapat diakses, silahkan hubungi CS',tipe:'default',icon:'warning'})
        }
    } else {
        next()
    }
})

export default router
